import { render, staticRenderFns } from "./BsGridCell.vue?vue&type=template&id=a4a795f8&scoped=true&"
import script from "./BsGridCell.vue?vue&type=script&lang=js&"
export * from "./BsGridCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a795f8",
  null
  
)

export default component.exports